// extracted by mini-css-extract-plugin
module.exports = {"cycle":"CycleListItem_cycle__1vn2K","title":"CycleListItem_title__2XeYp"};